<template>
	<div>
		<div class="d-flex flex-wrap justify-space-between">
			<h2 class="mb-4">Email Template</h2>
			<v-spacer></v-spacer>
			<v-btn v-if="emailTemplateList.length == 0" color="primary" @click="initiateEmailTemplate()">Create Initiate Email Template</v-btn>
		</div>
		<v-card v-if="emailTemplateList.length > 0">
			<v-tabs v-model="tab" background-color="primary" dark grow show-arrows>
				<v-tab v-for="(item, idxItem) in emailTemplateList" :key="idxItem">{{ item.type.replaceAll("_", " ") }}</v-tab>
			</v-tabs>

			<v-tabs-items v-model="tab">
				<v-tab-item v-for="(emailTemplate, idxEmailTemplate) in emailTemplateList" :key="idxEmailTemplate">
					<v-card flat>
						<v-card-text>
							<v-text-field v-model="emailTemplate.subject" label="Subject" outlined dense></v-text-field>
							<editor api-key="qd423wdft5go18d79gevmkpv8i92g9giyq6akdz5jc8ium67" :init="$root.initTinyMceFromVueEditor(420)" v-model="emailTemplate.template"></editor>
							<v-row style="margin:0px">
								<v-col cols="6">
									<div class="d-flex justify-start">
										<v-btn color="primary" class="mt-4" @click="resetEmailTemplate(emailTemplate)" style="margin-right:5px">Reset Email Template</v-btn>
									</div>
								</v-col>
								<v-col cols="6">
									<div class="d-flex justify-end">
										<v-btn color="primary" class="mt-4" @click="emailPreview(emailTemplate)" style="margin-right:5px">Preview</v-btn>
										<v-btn color="primary" class="mt-4" @click="inputRecipientEmail(emailTemplate)" style="margin-right:5px">Send Test Email</v-btn>
										<v-btn color="primary" class="mt-4" @click="save(emailTemplate)">Save</v-btn>
									</div>
								</v-col>
							</v-row>
							<strong>Available parameters</strong>
							<v-row>
								<v-col cols="12" sm="2">
									<code>{userName}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-if="$store.state.principal.type != 'Clinic' && !emailTemplate.type.includes('Meeting')">
								<v-col cols="12" sm="2">
									<code>{eventName}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-if="$store.state.principal.type != 'Clinic' && !emailTemplate.type.includes('Meeting')">
								<v-col cols="12" sm="2">
									<code>{eventTime}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-if="$store.state.principal.type != 'Clinic' && (emailTemplate.type == 'Email_Invitation' || emailTemplate.type == 'Reset_Password')">
								<v-col cols="12" sm="2">
									<code>{resetPasswordUrl}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-else-if="$store.state.principal.type != 'Clinic' && (emailTemplate.type !== 'Email_Invitation' && emailTemplate.type != 'Reset_Password' && !emailTemplate.type.includes('Meeting'))">
								<v-col cols="12" sm="2">
									<code>{eventUrl}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-if="$store.state.principal.type === 'Clinic'">
								<v-col cols="12" sm="2">
									<code>{consultationTime}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-if="$store.state.principal.type === 'Clinic'">
								<v-col cols="12" sm="2">
									<code>{consultationLink}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-if="$store.state.principal.type === 'Clinic'">
								<v-col cols="12" sm="2">
									<code>{password}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-if="$store.state.principal.type === 'Clinic'">
								<v-col cols="12" sm="2">
									<code>{experience}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-if="$store.state.principal.type === 'Clinic'">
								<v-col cols="12" sm="2">
									<code>{notes}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-if="emailTemplate.type == 'Meeting_Invitation' || emailTemplate.type == 'Cancel_Meeting'">
								<v-col cols="12" sm="2">
									<code>{meetingName}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-if="emailTemplate.type == 'Meeting_Invitation' || emailTemplate.type == 'Cancel_Meeting'">
								<v-col cols="12" sm="2">
									<code>{meetingTime}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-if="emailTemplate.type == 'Meeting_Invitation' || emailTemplate.type == 'Cancel_Meeting'">
								<v-col cols="12" sm="2">
									<code>{organizer}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-if="emailTemplate.type == 'Meeting_Invitation'">
								<v-col cols="12" sm="2">
									<code>{message}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-if="emailTemplate.type == 'Meeting_Invitation'">
								<v-col cols="12" sm="2">
									<code>{yesUrl}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-if="emailTemplate.type == 'Meeting_Invitation'">
								<v-col cols="12" sm="2">
									<code>{noUrl}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-if="emailTemplate.type == 'Meeting_Invitation'">
								<v-col cols="12" sm="2">
									<code>{downloadIcs}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
							<v-row v-if="emailTemplate.type == 'Meeting_Invitation'">
								<v-col cols="12" sm="2">
									<code>{extMeetingLink}</code>
								</v-col>
								<v-col></v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</v-card>

		<v-dialog
			v-if="showEmailPreview" 
			v-model="showEmailPreview"
			no-click-animation
			persistent
			transition="dialog-bottom-transition"
			content-class="col-sm-7 col-12 hide-box-shadow ma-0 pa-0"
			style="overflow: hidden"
			scrollable
			max-width="750px"
		>
			<v-card>
				<v-card-title class="headline">
					<v-spacer></v-spacer>
					<v-btn icon @click="showEmailPreview = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<h2>
						{{emailTemplateSubjectPreview}}
					</h2>
					<br />
					<div v-html="emailTemplatePreview"></div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-if="showSendTestEmail" v-model="showSendTestEmail" max-width="350" scrollable>
			<v-card>
				<v-form ref="sendTestEmail" v-model="valid" @submit.prevent="sendTestEmail">
				<v-card-text>
					<v-text-field v-model="recipientEmail" label="Email" :rules="[(v) => !!v || 'Email is required']"></v-text-field>
					<div class="d-flex justify-end">
						<v-btn color="primary darken-1" text @click="showSendTestEmail=false">Close</v-btn>
						<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Send</v-btn>
					</div>
				</v-card-text>
				</v-form>
			</v-card>
		</v-dialog>
	</div>
</template>
        
<script>
import axios from "axios";
import Editor from "@tinymce/tinymce-vue";

export default {
	props: ["experienceId"],
	components: {
		editor: Editor
	},
	data() {
		return {
			entity: {},
			emailTypes: [],
			emailTemplateList: [],
			isDefault: false,
			tab: null,
			items: ["Email Invitation", "Password Reset", "Password Reset Confirmation"],
			text:"",
			showEmailPreview: false,
			showSendTestEmail: false,
			emailTemplatePreview: null,
			emailTemplateSubjectPreview: null,
			recipientEmail: null,
			emailTemplateTest: {},
			valid: true
		};
	},
	mounted() {
		this.listEmailTemplate();
	},
	methods: {
		listEmailTemplate() {
			axios.get("/system/emailtemplate/list?experienceId=" + this.experienceId).then(response => {
				this.emailTemplateList = response.data;
				for (var i = 0; i < this.emailTemplateList.length; i++) {
					if (this.emailTemplateList[i].template) {
						if (this.emailTemplateList[i].type == 'Email_Invitation' || this.emailTemplateList[i].type == 'Reset_Password' ) {
							this.emailTemplateList[i].template = this.emailTemplateList[i].template.replace("{actionUrl}", "{resetPasswordUrl}")
						}
						if (this.emailTemplateList[i].type == 'Reset_Password_Confirmation' ) {
							this.emailTemplateList[i].template = this.emailTemplateList[i].template.replace("{actionUrl}", "{eventUrl}")
						}
						this.emailTemplateList[i].default = false;
					} else {
						this.emailTemplateList[i].default = true;
					}
				}
			});
		},
		initiateEmailTemplate() {
			let formData = new FormData();
			formData.append("experienceId", this.experienceId);
			axios.post("/system/emailtemplate/initiate", formData).then(() => {
				this.listEmailTemplate();
			});
		},
		save(entity) {
			let formData = new FormData();
			formData.append("entity", JSON.stringify(entity));
			axios.post("/system/emailtemplate/edit", formData).then(() => {
				this.listEmailTemplate();
			});
		},
		emailPreview(emailTemplate){
			axios
				.post("/system/emailtemplate/preview",{
					experienceId: this.experienceId,
					emailSubject: emailTemplate.subject,
					emailTemplate: emailTemplate.template,
					type: this.$store.state.principal.type
				})
				.then((response) => {
					this.emailTemplateSubjectPreview = response.data.subject;
					this.emailTemplatePreview = response.data.template;
					this.showEmailPreview = true;
				})
				.catch(() => {});
		},
		sendTestEmail(){
			axios
				.post("/system/emailtemplate/send/testemail",{
					experienceId: this.experienceId,
					emailTemplate: this.emailTemplateTest.template,
					emailSubject: this.emailTemplateTest.subject,
					type: this.$store.state.principal.type,
					recipientEmail: this.recipientEmail
				})
				.then(() => {
					this.showSendTestEmail = false;
					this.$refs.sendTestEmail.reset();
				})
				.catch(() => {});
		},
		inputRecipientEmail(emailTemplate){
			this.showSendTestEmail = true;
			this.emailTemplateTest = emailTemplate;
		},
		resetEmailTemplate(emailTemplate) {
			axios
				.post("/system/emailtemplate/reset",{
					id: emailTemplate.id,
					experienceId: this.experienceId
				})
				.then((response) => {
					if (response.data != null) {
						this.listEmailTemplate();
					}
				})
				.catch(() => {});
		}
	}
};
</script>